import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom"; // ✅ useLocation import
import "../index.css";
import Logo from "../logo.png";

function Navbar() {
  const wrapperRef = useRef(null);
  const selectorRef = useRef(null);
  const location = useLocation(); // ✅ current path मिलेगा

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const selector = selectorRef.current;

    if (!wrapper || !selector) return;

    const items = wrapper.querySelectorAll("li.nav-item");

    function updateSelector(el) {
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const parentRect = wrapper.getBoundingClientRect();
      selector.style.width = `${rect.width}px`;
      selector.style.height = `${rect.height}px`;
      selector.style.transform = `translate(${rect.left - parentRect.left}px, ${rect.top - parentRect.top}px)`;
    }

    // ✅ active item choose by URL path
    const currentItem = Array.from(items).find(
      (li) => li.querySelector("a")?.getAttribute("href") === location.pathname,
    );

    updateSelector(currentItem || items[0]);

    items.forEach((li) => {
      li.addEventListener("click", function () {
        items.forEach((i) => i.classList.remove("active"));
        this.classList.add("active");
        updateSelector(this);
      });
    });

    function onResize() {
      const cur =
        wrapper.querySelector("li.nav-item.active") ||
        wrapper.querySelector("li.nav-item");
      updateSelector(cur);
    }
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
      items.forEach((li) => {
        li.replaceWith(li.cloneNode(true));
      });
    };
  }, [location.pathname]); // ✅ हर बार path change होने पर re-run

  return (
    <nav className="navbar navbar-expand-lg navbar-mainbg three-d-nav fixed-top py-2 rounded-bottom-2" style={{ width: '100%', maxWidth: '1400px', margin: '0 auto' }}>
      <div className="container-fluid">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img src={Logo} alt="logo" className="nav-logo me-2" />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="toggler-inner">
            <i className="fas fa-bars text-white"></i>
          </span>
        </button>

        <div className="collapse navbar-collapse border-start border-end border-dark" id="navbarSupportedContent">
          <ul
            className="navbar-nav m-auto align-items-center nav-wrapper"
            ref={wrapperRef}
          >
            {/* <div className="hori-selector" ref={selectorRef} aria-hidden="true" /> */}

            <li
              className={`nav-item ${location.pathname === "/" ? "active" : ""}`}
            >
              <Link className="nav-link d-flex align-items-center " to="/">
                <i className="fas fa-home me-2"></i>Home
              </Link>
            </li>

            <li
              className={`nav-item ${location.pathname === "/services" ? "active" : ""}`}
            >
              <Link
                className="nav-link d-flex align-items-center"
                to="/services"
              >
                <i className="fas fa-box-open me-2"></i>Services
              </Link>
            </li>

            <li
              className={`nav-item ${location.pathname === "/company" ? "active" : ""}`}
            >
              <Link
                className="nav-link d-flex align-items-center"
                to="/company"
              >
                <i className="fas fa-info-circle me-2"></i>Company
              </Link>
            </li>

            <li
              className={`nav-item ${location.pathname === "/blogs" ? "active" : ""}`}
            >
              <Link className="nav-link d-flex align-items-center" to="/blogs">
                <i className="fas fa-info-circle me-2"></i>Blogs
              </Link>
            </li>

            <li
              className={`nav-item ${location.pathname === "/customer" ? "active" : ""}`}
            >
              <Link
                className="nav-link d-flex align-items-center"
                to="/customer"
              >
                <i className="fas fa-tools me-2"></i>Customers
              </Link>
            </li>

            <li
              className={`nav-item ${location.pathname === "/faq" ? "active" : ""}`}
            >
              <Link className="nav-link d-flex align-items-center" to="/faq">
                <i className="fas fa-question-circle me-2"></i>FAQ
              </Link>
            </li>
          </ul>
        </div>

        <ul
          className="navbar-nav ms-5 align-items-center nav-wrapper"
          ref={wrapperRef}
        >
          <li
            className={`nav-item contact mb-0`}>
            <Link className="nav-link d-flex align-items-center" to="/contact">
              <i className="fas fa-mobile-alt me-2"></i>Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
